var _g, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInProgressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2020_227875)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 12,
    r: 12,
    fill: "#E7EDFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 12,
    r: 11.2,
    stroke: "#646B87",
    strokeWidth: 1.6
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12C9.5 13.2856 9.88122 14.5423 10.5954 15.6112C11.3097 16.6801 12.3248 17.5132 13.5126 18.0052C14.7003 18.4972 16.0072 18.6259 17.2681 18.3751C18.529 18.1243 19.6872 17.5052 20.5962 16.5962C21.5052 15.6872 22.1243 14.529 22.3751 13.2681C22.6259 12.0072 22.4972 10.7003 22.0052 9.51256C21.5132 8.32484 20.6801 7.30968 19.6112 6.59545C18.5423 5.88122 17.2856 5.5 16 5.5V7.03527C16.9819 7.03527 17.9418 7.32645 18.7583 7.87198C19.5747 8.41751 20.211 9.1929 20.5868 10.1001C20.9626 11.0073 21.0609 12.0055 20.8693 12.9686C20.6778 13.9316 20.2049 14.8163 19.5106 15.5106C18.8163 16.2049 17.9316 16.6778 16.9686 16.8693C16.0055 17.0609 15.0073 16.9626 14.1001 16.5868C13.1929 16.211 12.4175 15.5747 11.872 14.7583C11.3264 13.9418 11.0353 12.9819 11.0353 12H9.5Z",
    fill: "#646B87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9042 7.96482C10.397 8.60536 10.0151 9.33579 9.77847 10.1178L11.2934 10.5761C11.4724 9.98453 11.7613 9.43197 12.145 8.9474L10.9042 7.96482Z",
    fill: "#646B87"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3607 5.71012C13.57 5.91618 12.8253 6.26946 12.1656 6.75144L13.0881 8.01423C13.5892 7.64821 14.1547 7.37993 14.7551 7.22345L14.3607 5.71012Z",
    fill: "#646B87"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2020_227875",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2020_227875"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2020_227875",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgressIcon);
export default __webpack_public_path__ + "static/media/inProgress-icon.b4119c72de9a71e90539895879f5e5e9.svg";
export { ForwardRef as ReactComponent };